import React from 'react'
import {makeStyles} from 'external/material'
import Box from '@mui/material/Box'
import {AssignedContentIcon} from '../../../../resources/icons'


const useStyles = makeStyles(infoBarStyles)

export default function InfoBar ({context}) {

  const {quizAssignmentToModify: assignment} = context
  const classes = useStyles()
  return (
    <Box className={classes.root}>
      <Box className={classes.middle}>
        <AssignedContentIcon fill="#4f576e" />
      </Box>
      <Box className={`${classes.middle} ${classes.label}`}>
        {assignment.title}
      </Box>
    </Box>
  )
}

function infoBarStyles(theme){
  return {
    root: {
      display: 'flex',
      borderBottom: 'solid 1px #dbe3e6',
      padding: 10,
      minHeight: '40px',
    },
    middle: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
    },
    label: {
      marginLeft: 10,
      fontSize: '14pt',
      [theme.breakpoints.down('md')]: {
        fontSize: theme.typography.pxToRem(15),
      },
    },
  };
}
